import { IconFont } from '@/components'
import React from 'react'
import styled from 'styled-components'

const FilterIcon: React.FC<{
  filtered?: boolean
}> = ({ filtered }) => <Icon type="icon-a-shaixuan1" $filtered={filtered} />

export default FilterIcon

const Icon = styled(IconFont)`
  font-size: 14px;
  color: ${props => (props.$filtered ? '#4238C9' : '#999')};
  cursor: pointer;
  transition: color 0.3s;

  &:hover {
    color: #4238c9;
  }
`
